import { AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

// FormGroup validator for matching 2 FormControl values
export function MustMatch(controlName: string, matchingControlName: string) {
  return (formGroup: FormGroup): { [key: string]: any } => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // Return if another validator has already found an error
      return;
    }

    // Set error if validation fails
    if (control.value !== matchingControl.value) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

// FormGroup validator for matching 2 FormControl values if the first one is equal to the provided parameter value
export function MustMatchIfValue(
  controlName: string,
  matchingControlName: string,
  value: string,
  isDifferent = false
) {
  return (formGroup: FormGroup): { [key: string]: any } => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (matchingControl.errors && !matchingControl.errors.mustMatch) {
      // Return if another validator has already found an error
      return;
    }

    // Set error if validation fails
    const isMatching = control.value === value;
    if (
      isMatching === !isDifferent &&
      control.value !== matchingControl.value
    ) {
      matchingControl.setErrors({ mustMatch: true });
    } else {
      matchingControl.setErrors(null);
    }
  };
}

// Check if a property of the control matches the RegExp
// If "bypassIfEmptyProperty" is set then it will check if that property is not empty
export function PropertyPatternValidation(
  property: string,
  pattern: RegExp,
  bypassIfEmptyProperty: string = undefined
) {
  return (control: AbstractControl) => {
    const propertyValue = control.value[property];
    if (
      !propertyValue ||
      pattern.test(propertyValue) ||
      (bypassIfEmptyProperty && !control.value[bypassIfEmptyProperty])
    ) {
      return null;
    }

    return { propertyPattern: false };
  };
}

export function validateSingleSpaceEntries(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => (!control.value.trim().length ? { invalid: true } : null);
}



// WEBPACK FOOTER //
// ./ts/app/shared/form-validations/custom-validators.ts